// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1Ot6L","title":"styles-module__title___2MTQG","details":"styles-module__details___3TSmE","table":"styles-module__table___V4X-u"};